import FetchInterceptor from "configs/FetchInterceptor";

class StockInjectionServices {
  static async getAll(requestBody) {
    const apiUrl = `/v1/initial-stock`;
    const response = await FetchInterceptor.get(apiUrl, { params: requestBody });
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/v1/initial-stock/";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/v1/initial-stock/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }
}

export default StockInjectionServices;
